export const API_ACTIONS = {
  ADD_AMENITY: 'add_custom_amenity',
  PROJECTS_REFRESH: 'projects_refresh',
};

export const actionAddCustomAmenity = payload => ({
  type: API_ACTIONS.ADD_AMENITY,
  payload,
});
